export type InstrumentFilter = (typeof INSTRUMENT_FILTERS)[keyof typeof INSTRUMENT_FILTERS];

export const FUNDING_AMOUNT_HEADER_ID = 'fundingAmount';

export const PREMIUM_NOMINAL_HEADER_ID = 'premiumNominal';

export const NUMBER_OF_SECURITIES_HEADER_ID = 'numberOfSecurities';

export const INSTRUMENT_HEADER_ID = 'instrument';

export const FUNDING_TYPE_HEADER_ID = 'fundingType';

export const INSTRUMENT_FILTERS = {
    ALL: 'ALL',
    EQUITY_PREFERENCE: 'EQUITY_PREFERENCE',
    DEBENTURES_CONVERTIBLE: 'DEBENTURES_CONVERTIBLE',
} as const;

export const INSTRUMENT_FILTER_OPTIONS = [
    { id: INSTRUMENT_FILTERS.ALL, label: 'All Instruments' },
    { id: INSTRUMENT_FILTERS.EQUITY_PREFERENCE, label: 'Equity/Preference' },
    { id: INSTRUMENT_FILTERS.DEBENTURES_CONVERTIBLE, label: 'Debentures/ Convertible' },
];

export const DEBENTURE_OR_CONVERTIBLE_INSTRUMENT = /\b(debentures?|convertible|bonds?|notes?)\b/i;

export const RUPEE_PREFIX = '₹ ';

export const NO_MCA_DATA_MESSAGE = 'No data available on MCA';

export const EMPTY_TABLE_MESSAGES: Record<InstrumentFilter, string> = {
    [INSTRUMENT_FILTERS.ALL]: 'No funding history found on MCA',
    [INSTRUMENT_FILTERS.EQUITY_PREFERENCE]: 'No equity or preference allotments found on MCA',
    [INSTRUMENT_FILTERS.DEBENTURES_CONVERTIBLE]: 'No debenture or convertible allotments found on MCA',
};

export const LAST_UPDATED_LABEL = 'Last Updated on';

export const PDF_LAST_UPDATED_LABEL = 'Last updated on';
